import { format_address } from 'Data/format.js'

export function transformRecipients(data) {
  if (!data) {
    return []
  }

  let responsibleParties = (data.person.to_person_relationships || [])
    .map(relationship => relationship?.from_person_record)
    .filter(Boolean)
    .map(person => ({
      id: person._id,
      text: `${person.first_name} ${person.last_name}`,
    }))

  let professionals = (data.professional_relationships || [])
    .flatMap(relationship => {
      switch (relationship.dtype) {
        case 'emploProfessionalRelationship':
          return (
            relationship.employee.provider?.employee_resources?.map(
              resource => ({
                id: resource.employment_contract.person._id,
                text: `${resource.employment_contract.person.first_name} ${resource.employment_contract.person.last_name} (Professional)`,
              })
            ) || []
          )
        case 'otherProfessionalRelationship':
          return [
            {
              id: relationship.other.person._id,
              text: `${relationship.other.person.first_name} ${relationship.other.person.last_name} (External professional)`,
            },
          ]
        default:
          return []
      }
    })
    .filter(Boolean)

  // add the currently selected patient too
  let patient = {
    id: data.person._id,
    text: `${data.person.first_name} ${data.person.last_name}`,
  }

  return [patient, ...responsibleParties, ...professionals]
}

export function transformPostalAddresses(data) {
  return (
    data?.map(d => ({
      id: d.postal_address._id,
      text: format_address(d.postal_address),
    })) || []
  )
}
